(() => {
  if (window.voltaireSerpentBackground) return;
  window.voltaireSerpentBackground = true;
  const controllers = new Map();

  function init(root = document) {
    root.querySelectorAll('[data-serpent-background]').forEach(host => {
      if (controllers.has(host)) return;
      const video = host.querySelector('.v-serpent-film video');
      const button = host.querySelector('[data-serpent-motion]');
      if (!video || !button) return;
      const reduce = matchMedia('(prefers-reduced-motion: reduce)');
      let visible = !('IntersectionObserver' in window);
      let userPaused = false;
      let failed = false;
      let disposed = false;
      video.muted = true;
      video.defaultMuted = true;
      video.defaultPlaybackRate = video.playbackRate = 0.5;

      const shouldPlay = () => !disposed && !failed && !reduce.matches && !userPaused && visible && !document.hidden;
      function sync() {
        button.hidden = reduce.matches || failed;
        if (!shouldPlay()) { video.pause(); return; }
        const promise = video.play();
        if (promise) promise.catch(() => {
          if (!shouldPlay()) return;
          userPaused = true;
          button.textContent = 'Play motion';
          button.setAttribute('aria-label', 'Play background video');
        });
      }
      const onPlaying = () => {
        if (!shouldPlay()) { video.pause(); return; }
        host.classList.add('has-video-frame');
        button.textContent = 'Pause motion';
        button.setAttribute('aria-label', 'Pause background video');
      };
      const onError = () => {
        failed = true;
        host.classList.remove('has-video-frame');
        sync();
      };
      const onClick = () => {
        userPaused = !userPaused;
        button.textContent = userPaused ? 'Play motion' : 'Pause motion';
        button.setAttribute('aria-label', userPaused ? 'Play background video' : 'Pause background video');
        sync();
      };
      video.addEventListener('playing', onPlaying);
      video.addEventListener('error', onError);
      button.addEventListener('click', onClick);
      reduce.addEventListener('change', sync);
      document.addEventListener('visibilitychange', sync);
      let observer;
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(entries => {
          visible = entries[0].isIntersecting;
          sync();
        }, {threshold: 0});
        observer.observe(host);
      }
      controllers.set(host, () => {
        disposed = true;
        video.pause();
        observer?.disconnect();
        video.removeEventListener('playing', onPlaying);
        video.removeEventListener('error', onError);
        button.removeEventListener('click', onClick);
        reduce.removeEventListener('change', sync);
        document.removeEventListener('visibilitychange', sync);
        controllers.delete(host);
      });
      sync();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((destroy, host) => { if (event.target.contains(host)) destroy(); });
  });
})();
